<template>
  <div>
    <div style="background-color: rgb(243.9, 244.2, 244.8);">
      <div class="first-picture-font">
        <div class="gothamBold">
          CONTACT US
        </div>
        <div class="puHuiTi-Medium" style="font-size: 24px;font-weight: lighter">
          联系我们
        </div>

        <el-image
            style="height: 40px;padding-top: 10px;  animation: smooth-bounce 2s infinite; /* 匀速跳动动画 */"
            :src="down" fit="cover"/>
      </div>
    </div>
    <div style="background-color: rgb(243.9, 244.2, 244.8);">

      <el-image
          style="width: 100%;height: 40vh"
          :src="product_1"
          fit="cover"
      />
      <el-row>
        <el-col class="gothamBold" :offset="3"
                style="text-align: left;margin-top: 50px;margin-bottom: 30px;font-weight: bold">
          <span class="profile-title" @click="contactUs">CONTACT US</span>
          <br>
          <div class="puHuiTi-regular" style="font-size: 2rem;margin-top: 5px;font-weight: lighter">
            联系我们
          </div>

        </el-col>
      </el-row>

      <div style="width: 80%;margin-left: 10%;padding-bottom: 100px;">
        <el-image
            style="width: 100%; height: 100%;margin-top: 100px"
            :src="company_location"
            fit="cover"
        />

      </div>

      <!--      <el-row>-->
      <!--        <el-col v-for="(row, index) in [0, 1, 2, 3]"-->
      <!--                :key="index"-->
      <!--                :offset="index === 0 ? 3 : 1"-->
      <!--                :span="4"-->
      <!--                style="margin-top: 20px; background-color: white; position: relative; height: 10rem; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);border-radius: 15px"-->
      <!--        >-->
      <!--          <div style="margin-top: 20px;width: 80%;margin-left: 10%">-->
      <!--            <div v-if="index === 0">-->
      <!--              <div style="font-size: 24px">-->
      <!--                联系电话-->
      <!--              </div>-->

      <!--              <div class="puHuiTi-Light" style="padding-top: 20px;font-weight: lighter">-->
      <!--                13505844365-->
      <!--              </div>-->

      <!--            </div>-->
      <!--            <div v-if="index === 1">-->
      <!--              <div style="font-size: 24px">-->
      <!--                公司地址-->
      <!--              </div>-->
      <!--              <div class="puHuiTi-Light" style="padding-top: 20px;font-weight: lighter">-->
      <!--                浙江省慈溪市龙山镇施公山村工业二道6号楼-->
      <!--              </div>-->

      <!--            </div>-->
      <!--            <div v-if="index === 2">-->

      <!--              <div style="font-size: 24px">-->
      <!--                公司邮箱-->
      <!--              </div>-->
      <!--              <div class="puHuiTi-Light" style="padding-top: 20px;font-weight: lighter">-->
      <!--                2322540522@qq.com-->
      <!--              </div>-->

      <!--            </div>-->
      <!--            <div v-if="index === 3">-->
      <!--              <div style="font-size: 24px">-->
      <!--                公司传真-->
      <!--              </div>-->
      <!--              <div class="puHuiTi-Light" style="padding-top: 20px;font-weight: lighter">-->
      <!--                0574-63901865-->
      <!--              </div>-->

      <!--            </div>-->
      <!--          </div>-->

      <!--        </el-col>-->
      <!--      </el-row>-->

    </div>
  </div>
</template>

<script setup>

import down from "@/assets/img/down.png"
import company_location from "@/assets/img/company_location.jpg";
import router from "@/router";

let product_1 = "https://nb-dx.oss-cn-hangzhou.aliyuncs.com/dist/assets/img/news_1.jpg"


function contactUs() {
  router.push('contact_us');
}
</script>

<style scoped>
.factory-tab > /deep/ .el-tabs__header {
  background-color: white !important;
  height: 3rem;
}


/deep/ div.el-tabs.el-tabs--top.news-tab > div.el-tabs__header.is-top > div > div > div > div.el-tabs__active-bar.is-top {
  background-color: #003795; /* 红色激活条 */
}

/deep/ #tab-allNews {
  margin-left: 100px;
}
</style>